import { render, staticRenderFns } from "./CollectionTrend.vue?vue&type=template&id=98fb6e7c&scoped=true"
import script from "./CollectionTrend.vue?vue&type=script&lang=js"
export * from "./CollectionTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fb6e7c",
  null
  
)

export default component.exports